var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * Cookie container - helps manage reading and writing of cookies.
 * */
var CookieContainer = /** @class */ (function () {
    function CookieContainer() {
    }
    /**
     * Get cookie value.
     * @param cookie Name of the cookie.
     */
    CookieContainer.get = function (cookie) {
        var cookies = this.loadCookies();
        return cookies.has(cookie)
            ? cookies.get(cookie)
            : undefined;
    };
    /**
     * Set cookie value.
     * @param name Name of the value.
     * @param value New value for the cookie.
     * @param expiryDays Number of days after which the cookie expires.
     * @param domain Domain of the cookie.
     * @param path Path of the cookie.
     */
    CookieContainer.set = function (name, value, expiryDays, domain, path, secure, sameSite) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + expiryDays);
        var cookie = [
            name + "=" + value,
            "expires=" + exdate.toUTCString(),
            "path=" + (path || '/'),
            "secure=" + secure,
            "samesite=" + sameSite
        ];
        if (domain) {
            cookie.push("domain=" + domain);
        }
        var cookieString = cookie.join(';');
        document.cookie = cookieString;
    };
    /**
     * Delete cookie.
     * @param name Name of the cookie.
     * @param domain Domain of the cookie.
     * @param path Path of the cookie.
     */
    CookieContainer.delete = function (name, domain, path) {
        var cookies = this.loadCookies();
        if (cookies.has(name)) {
            var cookie = [
                name + "=",
                "expires=Thu, 01 Jan 1970 00:00:01 GMT",
                "path=" + (path || '/')
            ];
            if (domain) {
                cookie.push("domain=" + domain);
            }
            var cookieString = cookie.join(';');
            document.cookie = cookieString;
        }
    };
    CookieContainer.loadCookies = function () {
        var map = new Map();
        if (document.cookie) {
            document.cookie.split(';')
                .map(function (pair) {
                var fragments = pair.trim().split('=');
                map.set(fragments[0], fragments[1]);
            });
        }
        return map;
    };
    /**
     * Find cookies which match the given regex pattern.
     * @param pattern Pattern to match.
     */
    CookieContainer.findCookies = function (pattern) {
        var e_1, _a;
        var cookies = this.loadCookies();
        var names = [];
        try {
            for (var _b = __values(cookies.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var cookieName = _c.value;
                if (pattern.test(cookieName))
                    names.push(cookieName);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return names;
    };
    return CookieContainer;
}());
export default CookieContainer;
